import { useEffect, useState } from "react";
import MindMappingReportList from "../MindMapping/MindMappingReportList";
import ReportList from "../ReportSubscriptionPage/ReportList";
import "./MobileReportList.css";

const STORAGE_KEY = "mobile_report_active_tab";

export default function MobileReportList({ setToggle, onClose }) {
  // Replace your old useState with this "Lazy Initializer"
const [activeTab, setActiveTab] = useState(() => {
  const savedTab = localStorage.getItem(STORAGE_KEY);
  return savedTab || "subscription"; // Default to subscription if nothing is saved
});



  // Persist active tab
  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, activeTab);
  }, [activeTab]);

  return (
    <div className="mobile-report-wrapper-toggle">
      
      {/* TOGGLE HEADER */}
      <div className="mobile-report-type-toggle">
        <div className={`mobile-toggle-slider ${activeTab}`} />

        <button
          className={activeTab === "subscription" ? "active" : ""}
          onClick={() => setActiveTab("subscription")}
        >
          Idea Validation
        </button>

        <button
          className={activeTab === "mindmap" ? "active" : ""}
          onClick={() => setActiveTab("mindmap")}
        >
          Mind Mapping
        </button>
      </div>

      {/* CONTENT */}
      <div className="mobile-report-content-toggle">
        {activeTab === "mindmap" && (
          <MindMappingReportList setToggle={setToggle} onClose={onClose} />
        )}

        {activeTab === "subscription" && (
          <ReportList setToggle={setToggle} onClose={onClose} />
        )}
      </div>
    </div>
  );
}
